import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiClient } from '../core/api-client.service';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { SuperAdminSettingsComponent } from './super-admin-settings.component';


@NgModule({
  declarations: [
    SuperAdminSettingsComponent
  ],
  imports: [
    CommonModule
    , BrowserModule
      , FormsModule,
      ReactiveFormsModule
    ],
   providers: [ApiClient],
})
export class SuperAdminSettingsModule { }
